export default __webpack_public_path__ + "atomic/_patterns/01-atoms/icon-facebook/_icon-facebook.twig";